import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CvsConfirmationConfig } from '@cvs/components/confirmation/confirmation.types';

@Component({
    selector: 'cvs-confirmation-dialog',
    templateUrl: './dialog.component.html',
    styles: [
        `
            .cvs-confirmation-dialog-panel {
                
                @screen md {
                    @apply w-128;
                }

                @screen lg {
                    @apply w-192;
                }

                .mat-mdc-dialog-container {
                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None
})
export class CvsConfirmationDialogComponent {
    /**
     * Constructor
     */
    constructor(@Inject(MAT_DIALOG_DATA) public data: CvsConfirmationConfig) {}
}
